import { combineReducers } from 'redux';

// Reducers
import Cart from './cart_reducer';
import Login from './login_reducer';
import Payment from './payment';

const Reducers = combineReducers({
  Cart,
  Login,
  Payment
});
export default Reducers;
